import api from './api';

export const getUserCart = (user, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Cart/GetUserCart/${user.id}`, config);
    }
}

export const deleteAllCartItems = (user, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Cart/DeleteAllCartItems/${user != null ? user?.id : ""}`, config);
    }
}

export const deleteCartItem = (itemConfig, event) => {
    let errors = [];
    if (!event) {
        errors.push('event');
    }
    if (!itemConfig) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return fetch(`${process.env.REACT_APP_URL}/Cart/DeleteCartItem/${event}`, {
            method: 'DELETE',
            ...itemConfig,
            body: ""
        })
    }

}